var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"nav-column",class:{'nav-column__empty':_vm.links.length===0}},[_vm._t("before"),_c('CustomList',{class:_vm.navListContainerClasses,attrs:{"elements":_vm.links},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var element = ref.element;
var index = ref.index;
return [_vm._t("default",function(){return [_c('CustomLink',_vm._b({},'CustomLink',element,false))]},{"element":element,"index":index})]}}],null,true)}),_vm._t("after")],2)}
var staticRenderFns = []

export { render, staticRenderFns }